import { fetchApi } from "./fetchApi";

export default {
  async get() {
    const response = await fetchApi({
      method: "GET",
      url: `/api/env`,
    });

    return response.data.result;
  },
};
